export const getCurrencySymbol = (currency: string = 'AUD'): string => {
  const currencyMap: Record<string, string> = {
    'AUD': '$',
    'USD': '$',
    'CAD': '$',
    'PHP': '₱',
    'EUR': '€',
    'GBP': '£',
    'JPY': '¥',
    'CNY': '¥',
    'SGD': '$',
    'NZD': '$',
  };
  
  return currencyMap[currency.toUpperCase()] || '$';
};

export const formatCurrency = (amount: number, currency: string = 'AUD'): string => {
  const symbol = getCurrencySymbol(currency);
  return `${symbol}${amount.toFixed(2)}`;
};